// Building hover labels — point at a placed building and a small tooltip names
// it + explains its purpose (so temples / schools / hospitals are identifiable
// at a glance). Toggleable via the 'buildingLabels' setting. Pure read-only:
// raycasts the building meshes on pointer-move and positions a DOM tooltip.

import * as THREE from 'three'
import { BuildingConfig } from '../config/balance.js'
import { getBuildingObjects } from './buildings.js'
import { getSetting } from '../game/settings.js'

// Plain-language purpose per building type (clearer than the terse balance
// descriptions). Falls back to the config description if a type is missing.
const PURPOSE = {
  GRANARY: 'Stores the harvest — boosts your rice yield.',
  TEMPLE: 'Converts wandering goons into loyal citizens as they pass through.',
  SCHOOL: 'Educates citizens (they earn more) and keeps kittens from turning feral.',
  HOSPITAL: 'Heals citizens wounded in goon raids.',
  WATCHTOWER: 'Guards the borders — rallies your citizens against goons.',
  SHOP: 'Trade hub — extra Mao Coin from passing commerce.',
}

export function createBuildingLabels({ camera, canvas }) {
  if (!camera || !canvas) return
  const tip = document.createElement('div')
  tip.className = 'building-tip'
  document.body.appendChild(tip)

  const ray = new THREE.Raycaster()
  const pointer = new THREE.Vector2()

  const hide = () => { tip.classList.remove('show'); canvas.style.cursor = '' }

  canvas.addEventListener('pointermove', (e) => {
    if (!getSetting('buildingLabels')) { hide(); return }
    const objs = getBuildingObjects()
    if (!objs.length) { hide(); return }
    const rect = canvas.getBoundingClientRect()
    pointer.x = ((e.clientX - rect.left) / rect.width) * 2 - 1
    pointer.y = -((e.clientY - rect.top) / rect.height) * 2 + 1
    ray.setFromCamera(pointer, camera)
    const hits = ray.intersectObjects(objs, true)
    if (!hits.length) { hide(); return }
    // Walk up from the hit mesh to the building root carrying buildingType.
    let o = hits[0].object
    let type = null
    while (o && !type) { type = o.userData?.buildingType; o = o.parent }
    const cfg = type && BuildingConfig[type]
    if (!cfg) { hide(); return }
    tip.innerHTML = `<strong>${cfg.name}</strong><span>${PURPOSE[type] ?? cfg.description}</span>`
    tip.style.left = `${e.clientX + 14}px`
    tip.style.top = `${e.clientY + 14}px`
    tip.classList.add('show')
    canvas.style.cursor = 'help'
  })
  canvas.addEventListener('pointerleave', hide)
}
